/* Fragrance Luxery - elegant scroll reveal (tiny, dependency-free)
 * Version securisee du 25/07/2026.
 *
 * REGLE ABSOLUE : aucun element ne doit rester invisible si le JavaScript
 * echoue, est bloque, ou si l'IntersectionObserver ne se declenche pas.
 *
 * Trois filets de securite :
 *   1. la classe 'lux-js' (qui declenche le masquage CSS) n'est posee QUE si
 *      l'API IntersectionObserver est reellement disponible et utilisable ;
 *   2. un watchdog revele tout si l'initialisation n'a pas eu lieu a temps ;
 *   3. un controle de sante verifie apres coup qu'aucun element visible a
 *      l'ecran n'est reste masque - sinon tout est revele.
 * Toute erreur JS, ici ou ailleurs sur la page, declenche aussi la revelation.
 */
(function () {
  'use strict';

  var docEl = document.documentElement;
  var HIDE_CLASS = 'lux-js';
  var SAFE_CLASS = 'lux-failsafe';
  var INVIEW_CLASS = 'lux-inview';
  var WATCHDOG_MS = 2500;

  var revealed = false;

  /* Filet de securite : rend definitivement tout le contenu visible. */
  function revealEverything() {
    if (revealed) return;
    revealed = true;
    try {
      docEl.classList.add(SAFE_CLASS);
    } catch (e) {
      /* dernier recours : on retire la classe qui masque */
      docEl.className = String(docEl.className).replace(HIDE_CLASS, '');
    }
  }

  /* Toute erreur JS non capturee sur la page revele le contenu.
   * On n'appelle pas preventDefault : le comportement du navigateur
   * et le reporting d'erreurs restent inchanges. */
  try {
    window.addEventListener('error', revealEverything);
    window.addEventListener('unhandledrejection', revealEverything);
  } catch (e) {}

  /* Capacites requises. Si l'une manque, on ne masque rien du tout :
   * le site s'affiche sans animation, ce qui est toujours preferable
   * a une page vide. */
  var supported = false;
  try {
    supported =
      'IntersectionObserver' in window &&
      'classList' in docEl &&
      typeof document.querySelectorAll === 'function';
  } catch (e) {
    supported = false;
  }

  var reducedMotion = false;
  try {
    reducedMotion =
      !!window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  if (!supported || reducedMotion) {
    return; /* 'lux-js' n'est jamais pose : rien n'est masque. */
  }

  docEl.classList.add(HIDE_CLASS);

  /* Watchdog : si init() n'a pas tourne dans le delai imparti
   * (script interrompu, DOMContentLoaded jamais atteint, onglet en
   * arriere-plan sur un mobile a court de memoire...), on revele tout. */
  var watchdog = window.setTimeout(revealEverything, WATCHDOG_MS);

  function init() {
    try {
      var els = document.querySelectorAll('.lux-reveal');

      if (!els.length) {
        window.clearTimeout(watchdog);
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              entries[i].target.classList.add(INVIEW_CLASS);
              io.unobserve(entries[i].target);
            }
          }
        },
        /* threshold 0 au lieu de 0.06 : une section plus haute que l'ecran
         * (la grille catalogue de l'accueil, par exemple) pouvait ne jamais
         * atteindre 6 % de visibilite sur un petit mobile et rester masquee. */
        { rootMargin: '0px 0px -5% 0px', threshold: 0 }
      );

      for (var j = 0; j < els.length; j++) {
        io.observe(els[j]);
      }

      window.clearTimeout(watchdog);

      /* Controle de sante : si un element est physiquement visible a l'ecran
       * mais n'a pas recu .lux-inview, c'est que l'observer ne fonctionne pas
       * sur cet appareil. On revele alors la totalite du contenu. */
      window.setTimeout(function () {
        try {
          var hidden = document.querySelectorAll('.lux-reveal:not(.lux-inview)');
          var vh = window.innerHeight || docEl.clientHeight;
          for (var k = 0; k < hidden.length; k++) {
            var r = hidden[k].getBoundingClientRect();
            if (r.top < vh && r.bottom > 0) {
              revealEverything();
              return;
            }
          }
        } catch (e) {
          revealEverything();
        }
      }, WATCHDOG_MS);
    } catch (e) {
      revealEverything();
    }
  }

  try {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  } catch (e) {
    revealEverything();
  }
})();
